import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { mobile } from "@sellernote/ui/src/styles/functions";

const utilityCardList = styled.ul`
  display: flex;
  gap: 24px;

  ${mobile(css`
    width: 100%;
    margin-left: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    background-color: ${COLOR.wh};
    border-radius: 4px;
    gap: 0;
    animation-delay: 0.4s;
  `)}
`;

export default {
  utilityCardList,
};
